const topOverlayBottom = () => {
  let bottom = 0;

  document.querySelectorAll('body *').forEach((el) => {
    const style = window.getComputedStyle(el);
    if (style.position !== 'fixed' && style.position !== 'sticky') return;

    const rect = el.getBoundingClientRect();
    if (rect.top <= 1 && rect.bottom > bottom && rect.bottom < window.innerHeight / 2 && rect.width > window.innerWidth / 2) {
      bottom = rect.bottom;
    }
  });

  return bottom;
};

export default function scrollIntoViewBelowHeader(element, gap = 12) {
  if (!element) return;

  const top = element.getBoundingClientRect().top + window.scrollY - topOverlayBottom() - gap;
  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
}
